import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBrandPageContentCall } from '@kfc-global/react-shared/redux/Actions/BrandPageAction';
import { getHeaderData, getFooterData, isMobileDevice, getHeaderContentData } from 'common/utilities/utils';
import { getCmsClient } from 'common/utilities/cmsClient';
import Header from 'organisms/HeaderComponent/Container/HeaderContainer';
import { Footer } from 'organisms/FooterComponent';
import get from 'lodash/get';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from '../../../homePageContainer/Constants/homePageContainerConstants';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { getMarketConfigContent } from '../../../../common/utilities/content';
import { BrandPageTemplates } from 'app/Constants';
import { NUTRITION_ALLERGEN } from 'common/constants/SharedConstants';
import { MobPdfViewer } from './MobPdfViewer';

const HostedBrandPageContainer = props => {
  const { routePath, hideNav } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const brandPageHistory = useHistory();

  const {
    marketPageContent: hostedBrandMarketPageContent,
    tenantReducerContent,
    userParams,
    brandPageContent,
    homePageContent,
  } = useSelector(data => {
    return {
      marketPageContent: data.marketConfigReducer?.response,
      tenantReducerContent: data.tenantReducer,
      userParams: data.appStateReducer?.userStatus,
      brandPageContent: data.brandPageReducer?.response,
      homePageContent: data.contentReducer?.response,
    };
  });
  const { header = {}, footer = {} } = hostedBrandMarketPageContent.headerData ?? {};
  const { headerData: brandedData = {} } = brandPageContent ?? {};
  const hostUrl = get(brandedData, 'hostUrl', '');
  const segmentedMarketingData = getHeaderData(header);
  const segmentedFooterData = getFooterData(footer);
  const segmentedHomePageData = getHeaderContentData(homePageContent) ?? {};
  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;
  const dispatch = useDispatch();
  const I_FRAME = `<iframe src="${hostUrl}" onload='(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+"px";}(this));' style="height:100vh;width:100%;border:none;overflow:hidden;"></iframe>`;

  const iframe = () => {
    return {
      __html: I_FRAME,
    };
  };
  const hostedComponent = (
    <div>
      <div id='hostedContentFrame' dangerouslySetInnerHTML={iframe()} />
    </div>
  );

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  }, [isMobile]);

  useEffect(() => {
    if (routePath) {
      dispatch(
        getBrandPageContentCall({
          object: getCmsClient(),
          contentFull: {
            content_type: BrandPageTemplates.Template1,
            select: 'sys.id,fields',
            'fields.routePath': routePath,
            include: 5,
          },
        }),
      );
    }
  }, [dispatch, routePath]);

  useEffect(() => {
    dispatch(getMarketConfigContent(tenantReducerContent));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tenantReducerContent?.country]);

  return (
    <>
      {segmentedMarketingData && (!hideNav || hideNav === false) && (
        <Header contentData={segmentedMarketingData} tenantReducerData={tenantReducerContent} userParams={userParams} />
      )}
      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
          contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
        }}
        userParams={userParams}
        showHeader={false}
      />
      {isMobile && brandedData.title === NUTRITION_ALLERGEN ? <MobPdfViewer hostUrl={hostUrl} /> : hostedComponent}
      {segmentedFooterData && (!hideNav || hideNav === false) && (
        <Footer history={brandPageHistory} contentData={segmentedFooterData} tenantReducerData={tenantReducerContent} />
      )}
    </>
  );
};

HostedBrandPageContainer.propTypes = {
  history: PropTypes.object,
  routePath: PropTypes.string.isRequired,
  hideNav: PropTypes.bool,
};

HostedBrandPageContainer.defaultProps = {
  history: {},
  hideNav: false,
};

export default HostedBrandPageContainer;
